
import { useState, useEffect } from 'react';

interface TimeLeft {
  days: number;
  hours: number;
  minutes: number;
}

export const useCountdown = (deadlineDate: Date) => {
  const [timeLeft, setTimeLeft] = useState<TimeLeft>({
    days: 0,
    hours: 0,
    minutes: 0
  });
  
  useEffect(() => {
    // Declare timer at the top of the effect to avoid temporal dead zone issues
    let timer: NodeJS.Timeout;
    
    const calculateTimeLeft = () => {
      const now = new Date();
      const difference = deadlineDate.getTime() - now.getTime();
      
      if (difference <= 0) {
        clearInterval(timer);
        setTimeLeft({
          days: 0,
          hours: 0,
          minutes: 0
        });
      } else {
        // Using Math.floor instead of Math.ceil for consistency
        const days = Math.floor(difference / (1000 * 60 * 60 * 24));
        const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
        
        setTimeLeft({
          days,
          hours,
          minutes
        });
      }
    };
    
    // Calculate initial time
    calculateTimeLeft();
    
    // Set up interval
    timer = setInterval(calculateTimeLeft, 1000);
    
    // Cleanup
    return () => clearInterval(timer);
  }, [deadlineDate]);

  return timeLeft;
};
